export default __webpack_public_path__ + "static/media/03_danek_info-min.d63a0c85.jpg";